import Resources from './resources';
import { SELECTED_CLASS } from '../components/report-filters/filter-constants';

export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export function isEmptyArray(arr) {
    return arr.length === 0;
}

export function moveItemToFrontArray(array, selector, value) {
    let selectedItem;

    if (array.length > 0 && value) {
        array = array.filter((item) => {
            if (item[selector] === value) {
                selectedItem = item;
            }

            return item[selector] !== value;
        });
        array.unshift(selectedItem);
    }

    return array;
}

export function isDefined(x) {
    return x !== undefined && x !== null;
}

export async function getConfiguration(name) {
    const windowObject = Resources.env.configuration.values;
    const config = isDefined(windowObject[name])
        ? JSON.parse(windowObject[name])
        : await Resources.env.getConfigurationItem(name);
    return config;
}

export const getHasNoStudents = (activeFilters, allClasses) => {
    const selectedClassId = activeFilters[SELECTED_CLASS].id;
    const result = allClasses.find((item) => item.id === selectedClassId);

    if (result) return result.isClassEmpty;

    return false;
};

export function log() {}



// WEBPACK FOOTER //
// ./helpers/utils.js